

import Vue from 'vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'



const dataList = [{
src:"",
name:"设备管理",
tags:["PostgreSQL","Oracle","PostgreSQL"],
discount:["2年8折","3年6折"],
money:"2000.00"
},{
src:"",
name:"设备管理",
tags:["PostgreSQL"],
discount:["2年8折"],
money:"2000.00"
},{
src:"",
name:"设备管理",
tags:["PostgreSQL","Oracle"],
discount:["2年8折","3年6折"],
money:"2000.00"
},{
src:"",
name:"设备管理",
tags:["Oracle"],
discount:["2年8折","3年6折"],
money:"1000.00"
},{
src:"",
name:"设备管理",
tags:["Oracle"],
discount:["2年8折","3年6折"],
money:"1000.00"
}]

export default {
components: {
XHeader,
Tab,
TabItem
},
data () {
return {
tabIndex:0,
dataList: dataList,
}
},
methods: {
checkSwich:function(item,index){
if(item.check){
Vue.set(item,'check',false);

}else{
Vue.set(item,'check',true);
}
}
}
}



// WEBPACK FOOTER //
// ./src/views/user/collectionManage.vue